<template>
  <div
    class="group form-input is-checkbox"
    :class="{ 'is-checked': isChecked }"
  >
    <label
      :for="'form_input_' + _uid"
      class="flex items-baseline cursor-pointer"
    >
      <div
        class="border-2 w-4 h-4 flex mr-2 group-hover:border-primary-600 p-px"
        :class="{
          'border-grey-400': !isChecked,
          'border-primary-600': isChecked
        }"
      >
        <div
          class="w-full m-px rounded-sm"
          :class="{
            'bg-primary-600': isChecked,
            'group-hover:bg-primary-300': !isChecked
          }"
        />
      </div>
      <input
        :id="'form_input_' + _uid"
        v-model="proxyChecked"
        :type="inputType"
        :value="value"
        class="hidden"
        :checked="isChecked"
        :readonly="loading || locked || readonly"
        :disabled="loading || locked || disabled"
        :required="required"
      />
      <div :class="['flex-1 font-semibold text-grey-800', labelClass ? labelClass : 'text-xs']">
        {{ label }}
        <slot />
      </div>
    </label>
  </div>
</template>

<script>
export default {
  name: "InputCheckbox",
  model: {
    prop: "checked",
    event: "change"
  },
  props: {
    value: {
      type: [String, Number, Boolean, Event],
      default: true
    },
    error: {
      type: Array,
      default: () => []
    },
    label: {
      type: String,
      default: ""
    },
    labelClass: {
      type: String,
      required: false,
      default: null
    },
    locked: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    inputType: {
      default: "checkbox",
      validator: function (value) {
        return ["checkbox", "radio"].indexOf(value) !== -1;
      }
    },
    checked: {
      type: [Array, Boolean],
      default: false
    }
  },
  computed: {
    isChecked() {
      return this.checked === true || this.checked === this.value;
    },
    proxyChecked: {
      get() {
        return this.checked;
      },
      set(val) {
        this.$emit("change", val);
      }
    }
  }
};
</script>
